import {ReactNode} from 'react'

type Props = {
  children?: ReactNode
}

export const Footer = ({children}: Props) => {
  return (
    <div className="flex flex-col d:flex-row justify-end gap-4 px-4 py-6 d:px-8 d:py-6 border-solid border-t border-gray-3 items-center border-solid border-t border-gray-3 bg-transparent">
      {children}
    </div>
  )
}
